'use client';

/**
 * Theme Style Injector (client half)
 * ==================================
 * Re-applies the tenant CSS variables on the client so /admin/branding
 * previews and config changes take effect without a reload.
 *
 * The FIRST paint is handled server-side: SiteConfigServerProvider renders
 * the same variables (from lib/config/themeVars.ts) as an inline <style>, so
 * pages no longer flash the crimson/ivory defaults from globals.css before
 * hydration. Keep both halves on the shared builder — never add a variable
 * here without adding it there.
 */

import { useEffect } from 'react';
import { SiteConfig } from '@/lib/config/siteConfig.shared';
import { buildThemeVars } from '@/lib/config/themeVars';

interface ThemeStyleInjectorProps {
  config: SiteConfig;
}

export function ThemeStyleInjector({ config }: ThemeStyleInjectorProps) {
  useEffect(() => {
    const root = document.documentElement;
    for (const [k, v] of Object.entries(buildThemeVars(config))) {
      root.style.setProperty(k, v);
    }
  }, [config.theme]);

  return null;
}
